import * as Jwp from "./jwplayer/jwplayerRender"

export const initialize = () => {
    const videos = Array.from(document.getElementsByClassName("videoAside"));
    for (let video of videos) {
        const
            videoId = video.getAttribute("data-video_id"),
            multimediofileId = video.getAttribute("data-multimediofile_id"),
            multimediofileJWKey = video.getAttribute("data-jwkey"),
            multimedioJWKey = video.getAttribute("data-multimediojwkey"),
            videoDestacado = video.getAttribute("data-destacado"),
            showAds = video.getAttribute("data-showads"),
            arrayTags = video.getAttribute("data-arraytags"),
            videoTagHome = video.getAttribute("data-videotag_home"),
            contenedor = video.getAttribute("data-contenedor"),
            titulo = video.getAttribute("data-titulo"),
            autoPlay = video.getAttribute("data-autoplay") === 1;

        if (videoId && multimediofileId) {
            Jwp.render(video,
                videoId,
                multimediofileId,
                multimedioJWKey,
                multimediofileJWKey,
                !!videoDestacado,
                showAds,
                autoPlay,
                arrayTags,
                videoTagHome,
                contenedor,
                titulo);
        }
    }
};


// WEBPACK FOOTER //
// ./Statics/scripts/common/video.js